export class UtilityFunc {


    public static setLocalStorage(key: string, val: any) {
    localStorage.setItem(key,val);
    }

    public static getLocalStorage(key) {
    return localStorage.getItem(key)
    }

    public static clearStorage(){
        localStorage.clear()
    }
}
